import { isNumber } from 'lodash';
import { useState } from 'react';

interface UseIndexProps {
  initialIndex?: number | null;
}


export const useIndex = ({ initialIndex = null }: UseIndexProps) => {
  const [index, setIndex] = useState<number | null>(initialIndex);

  const handleSetIndex = (index: number | null) => {
    setIndex(index);
  };

  const handleNextIndex = () => {
    setIndex((prevActiveStep) => isNumber(prevActiveStep) ? prevActiveStep + 1 : null);
  };

  const handleBackIndex = () => {
    setIndex((prevActiveStep) => isNumber(prevActiveStep) ? prevActiveStep - 1 : null);
  };

  const resetIndex = () => {
    setIndex(null);
  };

  const handleToggleIndex = (newIndex: number) => {
    if (index === newIndex) {
      resetIndex();
    } else {
      handleSetIndex(newIndex)
    }
  }


  return {
    index,
    handleSetIndex,
    handleNextIndex,
    handleBackIndex,
    handleToggleIndex,
    resetIndex,
  };
};